// extracted by mini-css-extract-plugin
module.exports = {"item":"j77es5QjYxholuSWMny6i","link":"_3PG_dEeoY7P3nXaFW7c3pF","icon":"_3BYuNZF7B9xHkGagcLiCw3"};